import { Reactable, Action } from "@reactables/core";
import { RxBuilder } from "@jauntin/reactables";

type TouchButtons =
  | "eventType"
  | "underwritingQuestions"
  | "eligibilityQuestions"
  | "venue"
  | "event"
  | "insured"
  | "insuranceContact"
  | "payment"
  | "purchase";

export interface TouchButtonsState {
  eventType: boolean;
  venue: boolean;
  event: boolean;
  insured: boolean;
  insuranceContact: boolean;
  payment: boolean;
  purchase: boolean;
  underwritingQuestions: boolean;
  eligibilityQuestions: boolean;
}

export interface TouchButtonsActions {
  touchButton: (button: TouchButtons) => void;
}

export const defaultInitialState: TouchButtonsState = {
  eventType: false,
  venue: false,
  event: false,
  insured: false,
  insuranceContact: false,
  payment: false,
  purchase: false,
  underwritingQuestions: false,
  eligibilityQuestions: false,
};

export const RxTouchButtons = ({
  initialState = defaultInitialState,
  sources = [],
}): Reactable<TouchButtonsState, TouchButtonsActions> =>
  RxBuilder({
    initialState,
    name: "rxTouchButtons",
    sources,
    reducers: {
      touchButton: (state, { payload }: Action<TouchButtons>) => ({
        ...state,
        [payload]: true,
      }),
      resetForm: () => defaultInitialState,
    },
  });
